import { Box, Grid, Typography } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import DataClient from '../../../../../../Service/general_data_service';
import DataService from "../../../../../../Service";

function CoacheeDetail(props) {
    const [pageData, setPageData] = useState([])
    const [empDetail, setEmpDetail] = React.useState({});
    useEffect(() => {
        getData()
    }, [])

    const getData = (params) => {
        DataClient.getData('assignment_details/fetch_coachee_details?assignment_id=' + props.location?.state?.currentAssignment?.id)
            .then((res) => {
                pageData.length = 0
                setPageData(pageData.concat(res.coachee_details))
                let empId = res.employee_id;
                if (empId) {
                    const params = {
                        employee_id: empId,
                        assignment_id: props.location?.state?.currentAssignment?.id
                    };
                    DataService.getDirectData(`/coaching_request_forms/employee_detail`, params)
                        .then((response) => {
                            let listData = response.employee_detail;
                            setEmpDetail(listData);
                            // setLoading(false);


                        })

                        .catch((err) => { });
                }
            })
            .catch((res) => {

            })
    }

    return <Box my={3}>
        <Grid container direction="row" justify="center" alignItems="center">
            <Grid item xs={12}>
                {pageData.filter((item, idx) => idx < 1).map((option) => {
                    return <Box mt={3}>
                        <Grid container direction="row" justify="center" alignItems="flex-start">
                            <Grid item xs={4}>
                                <Typography variant="h2">
                                    <Box textAlign="left" fontWeight="fontWeightBold">{option.label}</Box>
                                </Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <Typography variant="h2">
                                    <Box textAlign="left">{option.value}</Box>
                                </Typography>

                            </Grid>
                        </Grid>
                    </Box>
                })
                }

                {(empDetail.primary_email !== "" && empDetail.primary_email !== null) && <Box mt={3}>
                    <Grid container direction="row" justify="center" alignItems="flex-start">
                        <Grid item xs={4}>
                            <Typography variant="h2">
                                <Box textAlign="left" fontWeight="fontWeightBold">{"Primary email"}</Box>
                            </Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <Typography variant="h2">
                                <Box textAlign="left">{empDetail.primary_email}</Box>
                            </Typography>

                        </Grid>
                    </Grid>
                </Box>}
                {(empDetail.home_country !== "" && empDetail.home_country !== null) && <Box mt={3}>
                    <Grid container direction="row" justify="center" alignItems="flex-start">
                        <Grid item xs={4}>
                            <Typography variant="h2">
                                <Box textAlign="left" fontWeight="fontWeightBold">{"Home country"}</Box>
                            </Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <Typography variant="h2">
                                <Box textAlign="left">{empDetail.home_country}</Box>
                            </Typography>

                        </Grid>
                    </Grid>
                </Box>}
                {(empDetail.home_city !== "" && empDetail.home_city !== null) && <Box mt={3}>
                    <Grid container direction="row" justify="center" alignItems="flex-start">
                        <Grid item xs={4}>
                            <Typography variant="h2">
                                <Box textAlign="left" fontWeight="fontWeightBold">{"Home city"}</Box>
                            </Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <Typography variant="h2">
                                <Box textAlign="left">{empDetail.home_city}</Box>
                            </Typography>

                        </Grid>
                    </Grid>
                </Box>}
                {(empDetail.telephone !== "" && empDetail.telephone !== null) && <Box mt={3}>
                    <Grid container direction="row" justify="center" alignItems="flex-start">
                        <Grid item xs={4}>
                            <Typography variant="h2">
                                <Box textAlign="left" fontWeight="fontWeightBold">{"Telephone"}</Box>
                            </Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <Typography variant="h2">
                                <Box textAlign="left">{empDetail.telephone}</Box>
                            </Typography>

                        </Grid>
                    </Grid> </Box>}
                {/* </Box> */}
                {/* <Box mt={3}>
                           { empDetail.job_role !== "" && empDetail.job_role !== null &&  <Grid container direction="row" justify="center" alignItems="flex-start">
                                <Grid item xs={4}>
                                    <Typography variant="h4" style={{ color: "#232323" }}>
                                        <Box textAlign="left" fontWeight="fontWeightBold">{"Job role"}</Box>
                                    </Typography>
                                </Grid>
                                <Grid item xs={8}>
                                    <Typography variant="h4" style={{ color: "#232323" }}>
                                        <Box textAlign="left">{empDetail?.job_role}</Box>
                                    </Typography>

                                </Grid>
                            </Grid>}
                            </Box> */}
                {/* <Box mt={3}>
                    {(empDetail.level_or_grade !== "" && empDetail.level_or_grade !== null) && <Grid container direction="row" justify="center" alignItems="flex-start">
                        <Grid item xs={4}>
                            <Typography variant="h2" style={{ color: "#232323" }}>
                                <Box textAlign="left" fontWeight="fontWeightBold">{"Level"}</Box>
                            </Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <Typography variant="h4" style={{ color: "#232323" }}>
                                <Box textAlign="left">{empDetail.level_or_grade}</Box>
                            </Typography>

                        </Grid>
                    </Grid>}
                </Box> */}
                <Box mt={3}>
                    {(empDetail.level_or_grade !== "" && empDetail.level_or_grade !== null) && <Grid container direction="row" justify="center" alignItems="flex-start">
                        <Grid item xs={4}>
                            <Typography variant="h2">
                                <Box textAlign="left" fontWeight="fontWeightBold">{" Level/Band/Grade"}</Box>
                            </Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <Typography variant="h2">
                                <Box textAlign="left">{empDetail.level_or_grade}</Box>
                            </Typography>

                        </Grid>
                    </Grid>}
                    {(empDetail.pa_name !== "" && empDetail.pa_name !== null) && <Box mt={3}>
                        <Grid container direction="row" justify="center" alignItems="flex-start">
                            <Grid item xs={4}>
                                <Typography variant="h2">
                                    <Box textAlign="left" fontWeight="fontWeightBold">{"PA name"}</Box>
                                </Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <Typography variant="h2">
                                    <Box textAlign="left">{empDetail.pa_name}</Box>
                                </Typography>

                            </Grid>
                        </Grid>
                    </Box>}
                </Box>
                {(empDetail.pa_contact_details !== "" && empDetail.pa_contact_details !== null) && <Box mt={3}>
                    <Grid container direction="row" justify="center" alignItems="flex-start">
                        <Grid item xs={4}>
                            <Typography variant="h2">
                                <Box textAlign="left" fontWeight="fontWeightBold">{"PA contact details"}</Box>
                            </Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <Typography variant="h2">
                                <Box textAlign="left">{empDetail.pa_contact_details}</Box>
                            </Typography>

                        </Grid>
                    </Grid>
                </Box>}

                {(empDetail.line_manager_title !== "" && empDetail.line_manager_title !== null) && <Box mt={3}>
                    <Grid container direction="row" justify="center" alignItems="flex-start">
                        <Grid item xs={4}>
                            <Typography variant="h2">
                                <Box textAlign="left" fontWeight="fontWeightBold">{"Line manager title"}</Box>
                            </Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <Typography variant="h2">
                                <Box textAlign="left">{empDetail.line_manager_title}</Box>
                            </Typography>

                        </Grid>
                    </Grid>
                </Box>}
                <Box mt={3}>
                    {(empDetail.line_manager_name !== "" && empDetail.line_manager_name !== null) && <Grid container direction="row" justify="center" alignItems="flex-start">
                        <Grid item xs={4}>
                            <Typography variant="h2">
                                <Box textAlign="left" fontWeight="fontWeightBold">{"Line manager name"}</Box>
                            </Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <Typography variant="h2">
                                <Box textAlign="left">{empDetail.line_manager_name}</Box>
                            </Typography>

                        </Grid>
                    </Grid>}
                </Box>
                {(empDetail.line_manager_contact_details !== "" && empDetail.line_manager_contact_details !== null) && <Box mt={3}>
                    <Grid container direction="row" justify="center" alignItems="flex-start">
                        <Grid item xs={4}>
                            <Typography variant="h2">
                                <Box textAlign="left" fontWeight="fontWeightBold">{"Line manager contact details"}</Box>
                            </Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <Typography variant="h2">
                                <Box textAlign="left">{empDetail.line_manager_contact_details}</Box>
                            </Typography>

                        </Grid>
                    </Grid>
                </Box>}
                <Box mt={3}>
                    {(empDetail.line_manager_pa_name !== "" && empDetail.line_manager_pa_name !== null) && <Grid container direction="row" justify="center" alignItems="flex-start">
                        <Grid item xs={4}>
                            <Typography variant="h2">
                                <Box textAlign="left" fontWeight="fontWeightBold">{"Line manager PA name"}</Box>
                            </Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <Typography variant="h2">
                                <Box textAlign="left">{empDetail.line_manager_pa_name}</Box>
                            </Typography>

                        </Grid>
                    </Grid>}

                </Box>

                {(empDetail.line_manager_pa_contact_details !== "" && empDetail.line_manager_pa_contact_details !== null) && <Box mt={3}>
                    <Grid container direction="row" justify="center" alignItems="flex-start">
                        <Grid item xs={4}>
                            <Typography variant="h2">
                                <Box textAlign="left" fontWeight="fontWeightBold">{"Line manager PA contact details"}</Box>
                            </Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <Typography variant="h2">
                                <Box textAlign="left">{empDetail.line_manager_pa_contact_details}</Box>
                            </Typography>

                        </Grid>
                    </Grid>
                </Box>}

                {(empDetail.lob_leader_name !== "" && empDetail.lob_leader_name !== null) && <Box mt={3}>
                    <Grid container direction="row" justify="center" alignItems="flex-start">
                        <Grid item xs={4}>
                            <Typography variant="h2">
                                <Box textAlign="left" fontWeight="fontWeightBold">{"LOB leader name"}</Box>
                            </Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <Typography variant="h2">
                                <Box textAlign="left">{empDetail.lob_leader_name}</Box>
                            </Typography>

                        </Grid>
                    </Grid>
                </Box>}
                {(empDetail.hr_sponsor_title !== "" && empDetail.hr_sponsor_title !== null) && <Box mt={3}>
                    <Grid container direction="row" justify="center" alignItems="flex-start">
                        <Grid item xs={4}>
                            <Typography variant="h2">
                                <Box textAlign="left" fontWeight="fontWeightBold">{"HR sponsor title"}</Box>
                            </Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <Typography variant="h2">
                                <Box textAlign="left">{empDetail.hr_sponsor_title}</Box>
                            </Typography>

                        </Grid>
                    </Grid>
                </Box>}
                {(empDetail.hr_sponsor_name !== "" && empDetail.hr_sponsor_name !== null) && <Box mt={3}>
                    <Grid container direction="row" justify="center" alignItems="flex-start">
                        <Grid item xs={4}>
                            <Typography variant="h2">
                                <Box textAlign="left" fontWeight="fontWeightBold">{"HR sponsor name"}</Box>
                            </Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <Typography variant="h2">
                                <Box textAlign="left">{empDetail.hr_sponsor_name}</Box>
                            </Typography>

                        </Grid>
                    </Grid>
                </Box>}
                {(empDetail.hr_sponsor_contact_details !== "" && empDetail.hr_sponsor_contact_details !== null) && <Box mt={3}>
                    <Grid container direction="row" justify="center" alignItems="flex-start">
                        <Grid item xs={4}>
                            <Typography variant="h2">
                                <Box textAlign="left" fontWeight="fontWeightBold">{"HR sponsor contact details"}</Box>
                            </Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <Typography variant="h2">
                                <Box textAlign="left">{empDetail.hr_sponsor_contact_details}</Box>
                            </Typography>

                        </Grid>
                    </Grid>
                </Box>}
                {(empDetail.office_city !== "" && empDetail.office_city !== null) && <Box mt={3}>
                    <Grid container direction="row" justify="center" alignItems="flex-start">
                        <Grid item xs={4}>
                            <Typography variant="h2">
                                <Box textAlign="left" fontWeight="fontWeightBold">{"Office city"}</Box>
                            </Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <Typography variant="h2">
                                <Box textAlign="left">{empDetail.office_city}</Box>
                            </Typography>

                        </Grid>
                    </Grid>
                </Box>}
                {(empDetail.office_country !== "" && empDetail.office_country !== null) && <Box mt={3}>
                    <Grid container direction="row" justify="center" alignItems="flex-start">
                        <Grid item xs={4}>
                            <Typography variant="h2">
                                <Box textAlign="left" fontWeight="fontWeightBold">{"Office country"}</Box>
                            </Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <Typography variant="h2">
                                <Box textAlign="left">{empDetail.office_country}</Box>
                            </Typography>

                        </Grid>
                    </Grid>
                </Box>}






            </Grid>
        </Grid>

    </Box >
}

export default CoacheeDetail


